import { Input, Directive, HostBinding, OnChanges, SimpleChanges, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { DistributionChannel } from '../models/distributionChannelType';
import { AgTrackingService } from '@ag/vc.ag-core/tracking';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { SessionService } from '../../core/services/session.service';
import { ProductCodeRange } from '../models/LeadProducts';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[tracking]',
})
export class FormTrackingDirective implements AfterViewInit, OnChanges {
  constructor(
        private elementRef: ElementRef<HTMLElement>,
        private session: SessionService,
        private router: Router,
        private trackingService: AgTrackingService,
        @Inject(DOCUMENT) private readonly document: Document
  ) { }

    @Input() formname: string;
    @Input() stepname: string;
    @Input() stepoption: unknown;
    @Input() submittrigger: string; // Only necessary if the element isn't a form that already has a submit button
    @Input() laststep = false;
    @Input() IsIntervalCheckRequired = false;
    stepcluster: string;
    @Input() stepnumber: string;
    @Input() stepclusterOptional: string;
    message: string // this property will be used to differentiate between various products on LEAD (Eg: Uppie, Yongo, etc)

    @HostBinding('attr.data-tracking-event') event: boolean | string = false; // : 'form-step';
    @HostBinding('attr.data-tracking-info') info: boolean | string = false; // '{}';

    ngOnChanges(changes: SimpleChanges): void {
      if (changes.formname || changes.stepname || changes.stepoption || changes.stepnumber) {
        this.setStepCluster();
        this.setStepNumber();
        this.setMessageValue();
        if (!this.laststep) {
          setTimeout(() => {
            this.setTrackingData();
          }, 55);
        }
      }

      if (changes.submittrigger) {
        this.setClickTrigger();
      }
    }

    ngAfterViewInit(): void {
      setTimeout(() => {
        this.setClickTrigger();
      }, 60);
      if (this.IsIntervalCheckRequired) {
        this.checkBasedOnInverval();
      }
      if (this.laststep) {
        setTimeout(() => {
          this.trackingService.logFormLaststep(this.getTrackingData());
        }, 60);
      }
    }
    private setClickTrigger() {
      if (this.submittrigger && !this.laststep) {
        let items;
        if (typeof this.submittrigger === 'string') {
          items = this.document.querySelectorAll(this.submittrigger);
        } else {
          items = [this.submittrigger];
        }

        if (items) {
          for (const item of items) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            item.addEventListener('click', _event => {
              this.trackingService.trackSubmitForm(this.elementRef.nativeElement);
            });
          }
        }
      }
    }

    private checkBasedOnInverval() {
      let trigger = false;
      const interval = setInterval(() => {
        const items = this.document.querySelectorAll(this.submittrigger);
        if (items?.length > 0 && !trigger) {
          this.setClickTrigger();
          trigger = true;
        }
      }, 30);
      if (trigger) {
        clearInterval(interval);
      }
    }
    private setStepCluster() {
      const params = this.session.getUserParams();
      if (params && params.distributionChannel === DistributionChannel.AG && params.partnercode) {
        this.stepcluster = !this.stepclusterOptional ? 'Partner ' + params.partnercode : 'Partner ' + params.partnercode + ' | ' + this.stepclusterOptional;
      } else if (params && params.distributionChannel === DistributionChannel.Broker && params.partnercode) {
        this.stepcluster = 'Identified broker ' + params.partnercode;
      } else {
        this.stepcluster = 'Non-identified broker';
      }

    }

    private setStepNumber() {
      if (!this.stepnumber) {
        if (this.router.url.indexOf('/simulation/') > -1) {
          this.stepnumber = 'module 1 - v2';
        }
        if (this.router.url.indexOf('/authentication/') > -1
                || this.router.url.indexOf('/survey/') > -1
                || this.router.url.indexOf('/identification/') > -1
                || this.router.url.indexOf('/customer/i-continue') > -1 
                || this.router.url.indexOf('/OnlinePayment') > -1) {
          this.stepnumber = 'module 2';
        }
        if (this.router.url.indexOf('/onboarding/') > -1 || this.router.url.indexOf('/esign/') > -1) {
          this.stepnumber = 'module 3';
        }
        if (this.router.url.indexOf('/customer/') > -1) {
          this.stepnumber = 'module 4';
        }
        if (this.router.url.indexOf('/OnlinePayment') > -1) {
          this.stepnumber = 'payment flow';
        }
      }

    }

    private setMessageValue(): void {
      const currentProductCodeRange: ProductCodeRange = Number(this.session.getUserParams().partnercodeRange);
      if (currentProductCodeRange === ProductCodeRange.Uppie){
        this.message = 'uppie';
      }else if (currentProductCodeRange === ProductCodeRange.Yongo || currentProductCodeRange === ProductCodeRange.Yongo1){
        this.message = 'yongo';
      }else{
        this.message = 'no-context';
      }
    }

    private setTrackingData() {
      const value = this.getTrackingData();
      this.info = JSON.stringify(value);
      this.event = 'form-step';
    }

    private getTrackingData() {
      const value = {};

      if (this.formname) {
        value['formname'] = this.formname;
      }

      if (this.stepname) {
        value['stepname'] = this.stepname;
      }

      if (this.stepoption) {
        value['stepoption'] = this.stepoption;
      }

      if (this.stepcluster) {
        value['stepcluster'] = this.stepcluster;
      }

      if (this.stepnumber) {
        value['stepnumber'] = this.stepnumber;
      }

      if (this.message){
        value['message'] = this.message;
      }

      return value;
    }
}
